import React, { Component } from "react";

import logoLaddition from "../../img/logo.png";
import { Localized } from "fluent-react/compat";
import { FormattedMessage } from "react-intl";
import Buttons from "../user/ButtonPicker";
import CallApi from "../../utils/CallApi";
import SnackBar from "../user/SnackBar";
import { Link } from "react-router-dom";
import ClipboardJS from "clipboard";
import PropTypes from "prop-types";
import config from "../../config";
import Button from "./Button";
import moment from "moment";
import Popup from "./Popup";

// WARNING //
// ne pas activer le module si
// pas d'heure
// pas de menu
// pas d'adresse

class Publication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restaurantId: props.restaurantId,
      websiteUrl: props.restaurantAlias
        ? props.restaurantAlias
        : props.restaurantId,
      connect: false,
      scriptWebCopy: false,
      copy: false,
      openingHoursNotEmpty: true,
      tokenLaddition: props.token,
      token: "jkjkljjlk",
      tokenPost: "",
      tokenError: "",
      disabledApp: props.disabledApp,
      menuId: props.menuId,
      errror: "",
      successSnackbar: false,
      openSnackBar: false,
      contentSnack: "",
      showDisabledModal: false,
    };
  }

  componentDidMount() {
    const clip1 = new ClipboardJS(".url");
    const clip2 = new ClipboardJS(".script-web");
    const web = false;
    clip1.on("success", () => {
      this.setState(
        {
          scriptWebCopy: !!web ? true : false,
          copy: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              scriptWebCopy: false,
              copy: false,
            });
          }, 2500);
        }
      );
    });
    clip2.on("success", () => {
      this.setState(
        {
          scriptWebCopy: !!web ? true : false,
          copy: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              scriptWebCopy: false,
              copy: false,
            });
          }, 2500);
        }
      );
    });
  }

  enableApp = () => {
    this.setState(
      {
        disabledApp: {
          active: false,
          period: null,
        },
      },
      () => {
        this.submitDisabledApp();
      }
    );
  };

  openPopupDisabledApp = () => {
    this.setState({ showDisabledModal: true });
  }

  closePopupDisabledApp = () => {
    this.setState({ showDisabledModal: false });
  }

  submitDisabledApp = async () => {
    try {
      await CallApi(
        "put",
        "restaurant/admin/info",
        this.state.restaurantId,
        { update: "disabled", disabled: this.state.disabledApp },
        window.localStorage.getItem("refreshToken")
      );
      this.props.onUpdateDisabledApp({
        disabledApp: this.state.disabledApp,
      });
      this.setState(
        {
          success: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1200);
        }
      )
    } catch (e) {
      this.setState(
        {
          errors: <Localized id="tr-admin-error-data-modify" />,
        },
        () => {
          setTimeout(() => {
            this.setState({
              errors: "",
            });
          }, 1200);
        }
      );
    }
  };

  handleOptionChange = async (e, option) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    const optionName = value;
    let period;

    if (optionName === "today") {
      period = moment(new Date()).format("YYYY-MM-DD");
    } else if (optionName === "all") {
      period = "all";
    }

    this.setState(
      {
        [name]: value,
        disabledApp: { active: true, period: period },
        showDisabledModal: false,
      },
      () => {
        this.submitDisabledApp();
      }
    );
  };

  handleInputChange = (e) => {
    const value = e.target.value.replace(
      /[ !@#$€%^&*;é§èçà°(),.?":{}|<>+/'`=]/g,
      "-"
    );
    if (
      value.length > 1 &&
      value[value.length - 1] === "-" &&
      value[value.length - 2] === "-"
    )
      return;
    const newValue = value.toLowerCase();
    this.setState({ websiteUrl: newValue });
  };

  handleCloseSnack = () => {
    this.setState({
      openSnackBar: !this.state.openSnackBar,
    });
  };

  updateUrl = async () => {
    if (this.state.websiteUrl === this.props.restaurantAlias) {
      this.setState({
        openSnackBar: true,
        contentSnack: <Localized id="tr-admin-same-url" />,
        successSnackbar: true,
      });
      return;
    }

    const resultUpdate = await CallApi(
      "put",
      "restaurant/admin/info",
      this.state.restaurantId,
      { update: "updateAlias", alias: this.state.websiteUrl },
      window.localStorage.getItem("refreshToken")
    );
    const isSuccess = resultUpdate[0]["success"];
    const isExist = resultUpdate[0].result.updateRestaurantInfo.hasOwnProperty(
      "existingAlias"
    );

    if (isSuccess) {
      if (isExist) {
        this.setState({
          openSnackBar: true,
          contentSnack: <Localized id="tr-admin-error-url" />,
          successSnackbar: false,
        });
      } else {
        this.setState({
          openSnackBar: true,
          contentSnack: <Localized id="tr-admin-change" />,
          successSnackbar: true,
        });
        setTimeout(() => {
          this.props.onUpdateAlias(this.state.websiteUrl);
        }, 1800);
      }
    } else {
      this.setState({
        openSnackBar: true,
        contentSnack: <Localized id="tr-admin-change-error" />,
        successSnackbar: false,
      });
    }
  };

  resetUrl = () => {
    this.setState({ websiteUrl: this.state.restaurantId });
  };

  render() {
    const linkUserModule = `${config.urlIntegrate}${this.state.websiteUrl}`;


    const tokenLadditionInfo = (
      <Localized id="tr-admin-module-facebook-connected" />
    );

    const tokenLadditionError = (
      <p>
        <FormattedMessage
          id="integration.tokenLaddtiionError"
          defaultMessage="Un problème est survenu lors de la connexion entre votre caisse L'Addition et votre module de réservation. Veuillez nous contacter pour résoudre ce problème : {mail}"
          values={{
            mail: (
              <a href="mailto:reservation@laddition.com">
                reservation@laddition.com
              </a>
            ),
          }}
        />
      </p>
    );

    const selectOptionDisableApp = () => {
      return (
        <form>
          <div className="form-disableApp">
            <div className="radio">
              <input
                type="radio"
                value="all"
                id="all"
                name="disablaAppSelectedOptionName"
                onChange={this.handleOptionChange}
              />
              <label htmlFor="all">
                <Localized id="tr-admin-modify-module-active" />
              </label>
            </div>
            <div className="radio">
              <input
                type="radio"
                value="today"
                id="today"
                name="disablaAppSelectedOptionName"
                onChange={this.handleOptionChange}
              />
              <label htmlFor="today">
                <Localized id="tr-admin-modify-module-today" />
              </label>
            </div>
          </div>
          {this.state.errror ? this.state.errror : ""}
        </form>
      );
    };

    return (
      <div id="integration" className="container publication">
        <h3>
          <Localized id="tr-admin-tuto11-facebook" />
        </h3>
        <div className="pure-g container-publication">
          <div className="pure-u-md-1 pure-u-lg-2-5">
            <section className="section-fb">
              <div className="link">
                {this.props.openingHours !== null || "" ? (
                  <div className="script-web">
                    <div className="container-change-url">
                      <div className="container-label-input">
                        <label>
                          <Localized id="tr-update-url" />
                        </label>
                        <Localized
                          id="tr-example-url"
                          attrs={{ placeholder: true }}
                        >
                          <input
                            type="text"
                            name="newUrl"
                            placeholder
                            value={this.state.websiteUrl}
                            onChange={this.handleInputChange}
                          />
                        </Localized>
                      </div>
                      <Buttons
                        isUpdateInProcess={this.state.websiteUrl}
                        submitData={this.updateUrl}
                        removeData={this.resetUrl}
                      />
                    </div>
                    <p className="copy-link-module">
                      <Localized id="tr-admin-copy-link" />
                    </p>
                    <div className="container-url-module">
                      <span
                        className="url"
                        data-clipboard-text={linkUserModule}
                      >
                        {linkUserModule}
                      </span>
                    </div>
                    {!this.state.scriptWebCopy && !!this.state.copy ? (
                      <p className="confirm-copy">
                        <Localized id="tr-admin-link-copied" />
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  "error"
                )}
              </div>
            </section>
            <section className="container-disabled-app">
              <div>
                <h3 className="content-subhead">
                  <Localized id="tr-title-inactive" />
                </h3>
                <p className="explication-inactive-module">
                  <Localized id="tr-explication-inactive" />
                </p>
                <p className="disabled-app">
                  {this.state.disabledApp.active ? (
                    <React.Fragment>
                      {this.state.disabledApp.period &&
                      this.state.disabledApp.period !== "all" ? (
                        <Localized
                          id="tr-admin-for-today"
                          $hour={moment(this.state.disabledApp.period).format(
                            "DD/MM/YYYY"
                          )}
                        />
                      ) : (
                        <Localized id="tr-admin-module-disabled" />
                      )}
                    </React.Fragment>
                  ) : (
                    <Localized id="tr-admin-module-active" />
                  )}
                </p>
                {this.state.disabledApp.active ? (
                  <Button
                    disabledSubmit=""
                    submit={this.enableApp}
                    text={"tr-active"}
                    classCusto={"is-red is-blue-line"}
                  />
                ) : (
                  <Button
                    disabledSubmit=""
                    submit={this.openPopupDisabledApp}
                    text={"tr-inactive"}
                    classCusto={"is-red is-red-line"}
                  />
                )}

                {this.state.disabledApp &&
                !this.state.disabledApp.active &&
                this.state.showDisabledModal ? (
                  <Popup
                    title={<Localized id="tr-admin-module-not-active" />}
                    content={selectOptionDisableApp()}
                    close={this.closePopupDisabledApp}
                  />
                ) : (
                  ""
                )}
              </div>
            </section>
          </div>
          <section id="laddition" className="pure-u-md-1 pure-u-lg-2-5">
            <h3>
              <img src={logoLaddition} alt="logo l'addition" />
              <Localized id="tr-admin-connect-addition" />
            </h3>
            {this.state.tokenLaddition
              ? tokenLadditionInfo
              : tokenLadditionError}
            <div className="container-steps-activation-resa">
              <h3>
                <Localized id="tr-publication-title-step" />
              </h3>
              <ul>
                <li>
                  <Localized id="tr-publication-step1" />
                </li>
                <li>
                  <Localized id="tr-publication-step2" />
                </li>
                <li>
                  <Localized id="tr-publication-step3" />
                </li>
              </ul>
            </div>
          </section>
        </div>
        {this.state.openSnackBar ? (
          <SnackBar
            open={this.state.openSnackBar}
            handleCloseSnack={this.handleCloseSnack}
            text={this.state.contentSnack}
            success={this.state.successSnackbar}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
  static defaultProps = {
    openingDate: {},
    restaurantId: 1,
    tokenLaddition: "",
    disableApp: false,
  };
}

Publication.propTypes = {
  openingDate: PropTypes.object.isRequired,
  restaurantId: PropTypes.string.isRequired,
  tokenLaddition: PropTypes.string.isRequired,
  pageFacebookId: PropTypes.string,
  disableApp: PropTypes.bool,
  menuId: PropTypes.string,
  onUpdateFacebookPage: PropTypes.func.isRequired,
};

export default Publication;
